export {useStyles};

export const blackColor = "black";
export const paperColor = "white";
export const mainColor = "#d62a8e";
export const secondColor = "#3222a5";
export const thirdColor = "#E6F4FF";
export const disabledColor = "#8a8b8e";


export const artiHabitat="#5FD1F1"
export const artiMixte="#597FA5"
export const artiInconnue="#063C4B"
export const artiActive="#4225AB"

export const artiRou="#0b0421"
export const none="#a6a6a6"

export const statSup10 = "#17b459";
export const statSup1 = "#add293";
export const statSupMinus5 = "#eba873";

export const proprio = "#17b459";
export const locat = "#add293";
export const hlmLoc = "#eba873";

export const mainWhite = "white";
export const titleTextColor = "#302470";
export const mainTextColor = "#000000";
export const secondTextColor = "#3222a5";
export const BubbleColor = "#3222a5";
export const thirdTextColor = "white";

export const backgroundColor = "#EFEFEF";

export const statSupMinus10 = "#e30c25";



let defautMargin = "25px";
let font = '"Montserrat", "DejaVu Sans", "Arial", sans-serif';

let fontWidthThin = 200;
let fontWidthMedium = 300;
let fontWidthStrong = 400;
let fontWidthVeryStrong = 700;
let fontSizeVeryStrong = "1.8rem";
let fontLineHeightVeryStrong = "2.2rem";

let defaultMargin = "25px";

export let landCoverColor={
    "clc1": "#808080",
    "clc11": "#868686",
    "clc12": "#9f9f9f",
    "clc13": "#d3d3d3",
    "clc14": "#d6d6d6",
    "clc2": "#6c4801",
    "clc21": "#8a6d51",
    "clc22": "#ab8764",
    "clc23": "#c59b73",
    "clc24": "#eab787",
    "clc3": "#7bb401",
    "clc31": "#7db417",
    "clc32": "#98be10",
    "clc33": "#b3c70a",
    "clc34": "#cfd00a",
    "clc4": "#066559",
    "clc41": "#078070",
    "clc42": "#099b88",
    "clc43": "#0db7a1",
    "clc44": "#12dec3",
    "clc5": "#354475",
    "clc51": "#586694",
    "clc52": "#6d7caf",
    "clc53": "#6b7ebd",
    "clc54": "#91a9f8"
}
export {
    fontWidthThin,
    fontWidthMedium,
    fontWidthStrong,
    fontWidthVeryStrong,
    fontSizeVeryStrong,
    fontLineHeightVeryStrong,
    font
}

const textStyles = {
    main: {
        color: titleTextColor,
        fontFamily: font,

        fontWeight: fontWidthMedium,
        fontSize: "22px",
        lineHeight: "1.5em"
    }, title: {
        color: titleTextColor,
        fontFamily: font,
        fontWeight: fontWidthVeryStrong,
        fontSize: "1.5em",
        lineHeight: "1.5em",
        paddingBottom: "1em",
        paddingLeft: "0.5em",
    }, subTitle: {
        color: titleTextColor,
        fontFamily: font,
        fontWeight: fontWidthMedium,
        fontSize: "18px",
        lineHeight: "1.5em",
        paddingLeft: "0.5em",
        paddingBottom: "1em",
    }, contexte: {
        color: mainTextColor,
        fontFamily: font,
        fontWeight: fontWidthThin,
        fontSize: "1em",
        lineHeight: "2em",
        textAlign: "justify",
        whiteSpace: "pre-line",
        paddingBottom: "1em"
    }, text: {
        display: "list-item",
        color: mainTextColor,
        fontFamily: font,
        fontWeight: fontWidthThin,
        fontSize: "14px",
        lineHeight: "1.5em",
        textAlign: "justify",
        whiteSpace: "pre-line",
    }, text2: {
        color: mainTextColor,
        fontFamily: font,
        fontWeight: fontWidthThin,
        fontSize: "14px",
        lineHeight: "1.5em",
        textAlign: "justify",
        whiteSpace: "pre-line",
    }, textTitle: {
        color: mainTextColor,
        fontFamily: font,
        fontWeight: fontWidthVeryStrong,
        fontSize: "16px",
        lineHeight: "1.5em",
        textAlign: "justify",

        whiteSpace: "pre-line",

    }, analyse: {
        height: 120,
        color: mainTextColor,
        alignItems: "center",
        textAlign: "justify",
        flexDirection: "column",
        whiteSpace: "pre-line",
        fontFamily: font,

        fontSize: "12px",
        lineHeight: "1.5em"
    }

};


const useStyles = {
    texte: {
        legend: {
            color: mainTextColor,
            alignItems: "center",
            textAlign: "justify",
            flexDirection: "column",
            whiteSpace: "pre-line",
            fontFamily: font,
            fontSize: "12px",
            lineHeight: "1.5em"
        }
    },
    main: {
        loader: {
            width: "100vw", height: "10vh", display: "flex", alignItems: "center", justifyContent: "center"
        }, container: {
            margin: defautMargin, backgroundColor: paperColor,
            accordion: {
                '&:before': {
                    display: 'none',
                },
                boxShadow: "none",
                borderColor: "rgba(0, 0, 0, 0.125)",
                borderStyle: "solid",
                borderWidth: 1,

                header: {
                    backgroundColor: mainWhite,
                    color: titleTextColor,
                    borderRadius: "20px"
                }, icon: {
                    backgroundColor: mainColor,
                    "&:hover": {
                        backgroundColor: mainColor
                    },
                    color: mainWhite
                }, title: {
                    color: titleTextColor,
                    fontFamily: font,
                    fontSize: fontSizeVeryStrong,
                    lineHeight: fontLineHeightVeryStrong,
                    fontWeight: fontWidthVeryStrong
                }
            }

        },
    }, view: {
        subContainer: {
            marginTop: defautMargin, display: "flex", flexDirection: "column",
        }, subSubContainer: {
            display: "flex", flexDirection: "column",
        }, line: {
            display: "flex", flexDirection: "row",
        }, container: {
            mainTitle: textStyles.main,
            title: textStyles.title,
            subTitle: textStyles.subTitle,
            warning: {
                color: statSupMinus10,
                fontFamily: font,
                fontWeight: fontWidthMedium,
                fontSize: "18px",
                lineHeight: "1.5em",
                paddingLeft: "0.5em",
                paddingBottom: "1em",
            },
            contexteText: textStyles.contexte,
            textTitle: textStyles.textTitle,
            text: textStyles.text,
            text2: textStyles.text2
        },
    }, component: {
        list: {
            container: {
                width: {xs: "100%", sm: "70% ", md: "60%"},

                padding: 5,
                borderRadius: "4px",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                borderBottomLeftRadius: "30px",
                borderBottomRightRadius: "30px",
                backgroundColor: backgroundColor,
                marginBottom: "25px"
            }
        }, bubble: {
            main: {
                alignItems: "center"
            }, container: {
                display: "flex", flexDirection: "column",
                width: "300px",

            },
            container2: {
                display: "flex", flexDirection: "column",
                width: "100%"
            }, comment: {
                display: {xs: 'none', sm: 'none', md: 'none', lg: 'block'}
            }, mainBubble: {
                margin: "0.2em",
                padding: "0.8em",

                height: "15em",
                width: "15em",
                color: mainWhite,
                display: "flex",
                backgroundColor: secondTextColor,
                borderRadius: "50%",
                aspectRatio: "1/1",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",

            }, text: {
                title: {
                    fontFamily: font, fontWeight: fontWidthStrong, fontSize: "22px", lineHeight: "1.5em"

                }, subTitle: {
                    fontFamily: font,
                    fontWeight: fontWidthThin,
                    fontSize: "16px",
                    lineHeight: "1.5em",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "pre-line"
                }, analyse: {
                    height: 120,
                    color: mainTextColor,
                    alignItems: "center",
                    textAlign: "justify",
                    flexDirection: "column",
                    whiteSpace: "pre-line",
                    fontFamily: font,

                    fontSize: "12px",
                    lineHeight: "1.5em"
                },
            }, subBubble: {
                width: "13em",
                marginBottom: "0.2em",
                padding: "0.8em",
                color: secondTextColor,
                backgroundColor: thirdColor,
                display: "flex",
                borderRadius: 5,
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",

            }, rightSubBubble: {
                height: "50px",
                width: "110px",
                color: secondTextColor,
                backgroundColor: thirdColor,
                display: "flex",
                borderTopRightRadius: 30,
                borderBottomRightRadius: 30,
                textAlign: "center",
                alignItems: "center",
                justifyContent: "space-evenly",
                flexDirection: "row",

            }, secondPart: {
                alignContent: "flex-start", justifyContent: "space-between",

            }
        }, statCard: {
            container: {
                display: "flex",
                flexDirection: "column",
                margin: defautMargin,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                borderBottomLeftRadius: 30,
                borderBottomRightRadius: 30,
                backgroundColor: thirdColor,
                color: secondColor,
            }, text: {
                title: {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,

                    backgroundColor: mainColor,
                    color: mainWhite,
                    fontFamily: font,

                    fontWeight: fontWidthMedium,
                    fontSize: "16px",
                    textAlign: "justify",
                    whiteSpace: "pre-line",

                }, content: {}
            }
        }, rank: {
            display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", container: {
                borderRadius: 5,
                borderStyle: "solid",
                width: "100px",
                padding: 2,
                alignItems: "center",
                alignContent: "center",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column"
            }, text: {
                content: {
                    fontFamily: font, fontWeight: fontWidthThin, lineHeight: "1em", fontSize: "1em",
                }, value: {
                    fontFamily: font, fontWeight: fontWidthStrong, lineHeight: "1.2em", fontSize: "1.3em",
                }
            }
        }, card: {
            details: {
                container: {display: "flex", justifyContent: "center", flexDirection: "column"},
                content: {
                    hide: {display: "none"},
                    visible: {display: "block"}
                },
                box: {
                    margin: "5px"
                },
                subbox: {
                    marginRight: "20px"
                }
            }, header: {
                title: {
                    display: "flex",
                    justifyContent: "space-between",
                    lineHeight: "1.5em",
                    alignItems: "center",
                    maxWidth: "100%",
                    minWidth: "35px",
                    container: {
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        maxWidth: "60%",
                        minWidth: "35px",

                    },
                    headerTitle: {
                        color: mainWhite,
                        fontFamily: font,
                        fontWeight: fontWidthMedium,
                        fontSize: "16px",
                        textAlign: "justify",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",

                        width: "120px",
                    },
                    headerStatsTitle: {
                        color: mainWhite,
                        fontFamily: font,
                        fontWeight: fontWidthMedium,
                        fontSize: "16px",
                        textAlign: "justify",
                    },
                    headerTitleNb: {
                        color: mainWhite,
                        fontFamily: font,
                        fontWeight: fontWidthMedium,
                        fontSize: "16px",
                        textAlign: "justify",
                        width: "85px",
                    },
                    stats: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center',
                        flexDirection: "row",
                        graph: {
                            width: 19,
                            height: 19,
                            borderRadius: 50,
                            color: {
                                empty: mainWhite, full: blackColor,
                            }
                        },
                        graph2: {
                            width: 19,
                            height: 19,
                            borderRadius: 50,
                            color: {
                                empty: mainWhite, full: blackColor,
                            }
                        },
                        smallGraph: {
                            width: 19,
                            height: 19,
                            borderRadius: 50,
                            color: {
                                empty: mainWhite, full: blackColor,
                            }
                        },
                    }
                }, small: {
                    backgroundColor: mainColor,
                    color: mainWhite,

                    fontWeight: fontWidthMedium,
                    fontSize: "12px",
                    lineHeight: "1.5em"
                }, smallSelected: {
                    backgroundColor: secondColor,
                    color: mainWhite,

                    fontWeight: fontWidthMedium,
                    fontSize: "12px",
                    lineHeight: "1.5em"
                }, static: {
                    backgroundColor: mainColor, color: mainWhite, maxWidth: "100%",
                    "& .MuiCardHeader-content": {
                        flex: "1 1 auto",
                        width: "100%"
                    }
                }, dynamic: {
                    backgroundColor: disabledColor, color: mainWhite, maxWidth: "100%",
                    "& .MuiCardHeader-content": {
                        flex: "1 1 auto",
                        width: "100%"
                    }
                }, smallest: {
                    backgroundColor: mainColor, color: mainWhite, maxWidth: "100%",
                    "& .MuiCardHeader-content": {
                        flex: "1 1 auto",
                        width: "100%"
                    }
                },
            }, main: {
                minWidth: 250,
                marginBottom: defautMargin,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                borderBottomLeftRadius: 30,
                borderBottomRightRadius: 30,
                height: 'calc(100% - 20px)',
                title: {}
            }, main2: {
                minWidth: 250,
                marginBottom: defautMargin,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                borderBottomLeftRadius: 30,
                borderBottomRightRadius: 30,
                title: {}
            }, subContent: {}, subContent2: {
                width: "50%"
            }, content2: {
                backgroundColor: backgroundColor,
                color: secondColor,
                height: 'calc(100% - 20px)',
                display: "flex",
                flexDirection: "row"
            }, content: {
                backgroundColor: backgroundColor,
                color: secondColor,
                height: 'calc(100% - 20px)',
                display: "flex",
                flexDirection: "column",
                token: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    fontFamily: font,
                    fontWeight: fontWidthMedium,
                    fontSize: "15px",
                    lineHeight: "1.5em",
                    textAlign: "justify",
                    whiteSpace: "pre-line"
                },
                firstLine: {
                    alignItems: 'center',
                    justifyContent: "flex-start",
                    alignContent: "center",
                    flexWrap: 'wrap',
                    display: "flex",
                    whiteSpace: "pre-line",
                    marginRight: "10px",
                    fontFamily: font,

                    fontWeight: fontWidthMedium,
                    fontSize: "16px",
                    lineHeight: "1.5em",
                    color: secondColor,
                },
                title: {
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    justifyContent: "center",
                    whiteSpace: "pre-line",
                    marginRight: "10px",
                    fontFamily: font,

                    fontWeight: fontWidthMedium,
                    fontSize: "16px",
                    lineHeight: "1.5em",
                    color: mainWhite,
                },
                nextLine: {
                    paddingBottom: "10px",
                    borderBottomWidth: "1px",
                    borderBottomStyle: "solid",
                    borderBottomColor: disabledColor
                },
                previousLine: {
                    paddingTop: "10px",
                    borderTopWidth: "1px",
                    borderTopStyle: "solid",
                    borderTopColor: disabledColor
                },
                line: {
                    display: "flex", flexDirection: "row",
                },
                contexteTitle: {
                    color: secondColor,
                    fontFamily: font,

                    fontWeight: fontWidthMedium,
                    fontSize: "15px",
                    lineHeight: "1.5em",
                    textAlign: "justify",
                    whiteSpace: "pre-line",

                },
                contexteTextSmall: {
                    color: secondColor,
                    fontFamily: font,
                    fontWeight: fontWidthMedium,
                    fontSize: "0.7em",
                    lineHeight: "0.7em",
                    textAlign: "justify",
                    whiteSpace: "pre-line",
                },
                contexteText: {},
                contexteText2: {},
                contexteTextWithKpi: {
                    display: "flex",
                    flexWrap: 'wrap',
                    justifyContent: "center",
                    whiteSpace: "pre-line",
                    marginRight: "10px",
                    alignItems: "flex-start",
                    fontFamily: font,
                    fontWeight: fontWidthMedium,
                    fontSize: "16px",
                    lineHeight: "1.5em",
                },
                titleline: {
                    color: mainColor,
                    fontFamily: font,

                    fontWeight: fontWidthMedium,
                    fontSize: "16px",
                    lineHeight: "1.5em",
                    textAlign: "justify",
                    whiteSpace: "pre-line",
                }
            }
        }, stats: {
            display: "flex",
            color: "white",
            borderRadius: 10,
            paddingLeft: "1em",
            paddingRight: "1em",
            justifyContent: "center",
            marginBottom: "5px",
            alignItems: "center",
            minWidth: 55,
            content: {
                color: "white",
                fontSize: "1.3em",
                lineHeight: "1.5em",
            },
            content2: {
                color: "white",
                fontSize: "0.9em",
                lineHeight: "1.5em",
            }, content3: {
                color: "white",
                fontSize: "0.7em",
                lineHeight: "1.5em",
            }
        }, listOfStats: {
            container: {
                display: "flex", flexDirection: "row"
            }, bubble: {
                container: {
                    display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start"
                }, element: {}
            }
        }, leftBubble: {

            display: "flex",
            justifyContent: "space-between",
            lineHeight: "1.5em",
            color: mainWhite,
            height: 50,
            width: 155,
            backgroundColor: mainColor,
            alignItems: "center",
            borderTopRightRadius: 25,
            borderBottomRightRadius: 25,
            main: {
                zIndex: 1,
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px"
            },
            stats: {
                height: 50, display: "flex", alignItems: "center", justifyContent: "space-between",
            },
            text: {
                fontSize: "0.9em",
                paddingLeft: 1,
            },
            text2: {
                fontSize: "0.9em",
            },
            pie: {
                width: 19,
                height: 19,
                borderRadius: 50,
                color: {
                    empty: mainWhite,
                    full: blackColor,
                }
            }
        }, blob: {
            shape: {
                main: {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    marginTop: defaultMargin
                }, bubbleEmpty: {
                    display: "flex",
                    flexDirection: "column",
                    width: 150,
                    color: mainWhite,
                    backgroundColor: mainWhite,
                    borderRadius: 10,
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center"
                },
                bubble2: {
                    display: "flex",
                    flexDirection: "column",
                    width: 150,
                    padding: "25px",
                    color: mainWhite,
                    backgroundColor: "#8a8b8e",
                    borderRadius: 10,
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center"
                },
                bubbleFirst: {
                    display: "flex",
                    flexDirection: "column",
                    width: 150,
                    height: 150,
                    padding: "25px",
                    color: mainWhite,
                    backgroundColor: secondColor,
                    borderRadius: 70,
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center"
                },
                bubbleFirst2: {
                    display: "flex",
                    flexDirection: "column",
                    width: 100,
                    height: 100,
                    padding: "25px",
                    color: mainWhite,
                    backgroundColor: secondColor,
                    borderRadius: 70,
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center"
                },

                bubble: {
                    display: "flex",
                    flexDirection: "column",
                    width: 150,

                    padding: "25px",
                    color: mainWhite,
                    backgroundColor: "#8a8b8e",
                    borderRadius: 10,
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center"
                }, container: {
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center",

                }, one: {}, other: {},
                comment: {
                    display: "flex",
                    flexDirection: "column",
                    width: 200,
                    height: 50,
                    aspectRatio: "1/1",
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center"
                }
            }, text: {
                large2: {
                    color: mainWhite,
                    fontFamily: font,
                    fontWeight: fontWidthMedium,
                    fontSize: "1.2em",
                    lineHeight: "1.2em"
                }, small2: {
                    color: mainWhite, fontFamily: font, fontSize: "1.0em", lineHeight: "1.2em",
                    whiteSpace: "pre-line",

                }, tiny2: {
                    color: mainWhite, fontFamily: font,
                    fontSize: "1em",
                    lineHeight: "1em"
                },

                large: {
                    color: mainWhite,
                    fontFamily: font,
                    fontWeight: fontWidthMedium,
                    fontSize: "32px",
                    lineHeight: "1.5em"
                }, small: {
                    color: mainWhite, fontFamily: font, fontSize: "22px", lineHeight: "1.5em"
                }, tinyTitle: {
                    color: mainWhite,
                    fontFamily: font,
                    fontWeight: fontWidthMedium,
                    fontSize: "0.9em",
                    lineHeight: "1.5em"
                }, tiny: {
                    color: mainWhite, fontFamily: font, fontSize: "1.2em",
                    lineHeight: "1.5em"

                }, comment: {
                    color: mainTextColor,
                    fontFamily: font,
                    fontSize: "0.7em",
                    lineHeight: "1.5em"
                }
            }
        }
    }
};
